import styled from '@emotion/styled'

interface StyleCardProps {
  outline?: boolean
  bc?: string
  bg?: string
  radius?: number
  customStyle?: string
}

export const StyleCard = styled.div<StyleCardProps>`
  border-width: ${(props) => (props.outline ? '1px' : '0px')};
  border-color: ${(props: any) =>
    props.outline
      ? props.theme.colors[props.bc || 'borderColor']
      : 'transparent'};
  background: ${(props: any) => props.theme.colors[props.bg || 'white']};
  box-shadow: 0px 0px 4px -1px rgba(0, 0, 0, 0.12);
  border-radius: ${(props) => props.radius || 4}px;
  ${(props) => props.customStyle || ''}
`
